"use client";

import type { LucideIcon } from "lucide-react";

interface DebtTypeIconProps {
	icon: LucideIcon;
}

export const DebtTypeIcon = ({ icon: Icon }: DebtTypeIconProps) => (
	<div className="flex size-5 shrink-0 items-center justify-center rounded-full bg-[color-mix(in_srgb,var(--lea-color-purple-100)_50%,white)] text-primary-base">
		<Icon size={20} aria-hidden="true" />
	</div>
);
